import { Radio, RadioGroup, VStack, Divider, Image, Text, HStack, Icon } from '@chakra-ui/react';

import * as fp from 'lodash/fp';
import React from 'react';
import { IoChevronForwardOutline } from 'react-icons/io5';

import LINEPayImg from '~/assets/images/LINEPay.png';
import { PaymentType } from '~/types/common';

type PaymentTypeRadiogroupProps<T extends string> = {
  paymentType: T;
  paymentTypes: Array<T>;
  onChangePaymentType?: (type: T) => void;
  onOpenTzWalletModal: () => void;
};

export default function PaymentTypeRadioGroup<T extends string>({
  paymentType,
  paymentTypes,
  onChangePaymentType,
  onOpenTzWalletModal,
}: PaymentTypeRadiogroupProps<T>) {
  return (
    <RadioGroup value={paymentType} onChange={(e) => onChangePaymentType?.(e as T)}>
      <VStack align="stretch" spacing={0}>
        {paymentTypes.map((paymentType) => (
          <React.Fragment key={paymentType}>
            <PaymentTypeRadio paymentType={paymentType} onPressRightText={onOpenTzWalletModal} />
            <Divider borderColor="gray.200" />
          </React.Fragment>
        ))}
      </VStack>
    </RadioGroup>
  );
}

type PaymentTypeRadioProps<T extends string> = {
  paymentType: T;
  onPressRightText: () => void;
};

function PaymentTypeRadio<T extends string>({
  paymentType,
  onPressRightText,
}: PaymentTypeRadioProps<T>) {
  return fp.cond<T, JSX.Element | null>([
    [
      fp.eq(PaymentType.PLATFORM),
      (type) => (
        <Radio py={3} value={type}>
          <Text fontSize="sm">企業統一付款</Text>
        </Radio>
      ),
    ],
    [
      fp.eq(PaymentType.LINEPAY),
      (type) => (
        <Radio py={3} value={type}>
          <Image src={LINEPayImg} h="20px" />
        </Radio>
      ),
    ],
    [
      fp.eq(PaymentType.CASH),
      (type) => (
        <Radio py={3} value={type}>
          <Text fontSize="sm">現金付款</Text>
        </Radio>
      ),
    ],
    [
      fp.eq(PaymentType.CREDIT),
      (type) => (
        <Radio py={3} value={type}>
          <Text fontSize="sm">信用卡付費</Text>
        </Radio>
      ),
    ],
    [
      fp.eq(PaymentType.TZ_WALLET),
      (type) => (
        <VStack align="stretch">
          <HStack align="center" justify="space-between">
            <Radio pt={3} value={type} flex={1}>
              <Text fontSize="sm">慈濟錢包</Text>
            </Radio>
            <HStack spacing="0" align="center" onClick={onPressRightText} cursor="pointer">
              <Text fontSize="xs" fontWeight="700" color="gray.500">
                進行帳號綁定
              </Text>
              <Icon as={IoChevronForwardOutline} boxSize="1rem" color="gray.500" />
            </HStack>
          </HStack>
          <Text px={2} pb={3} fontSize={12}>
            不提供電子發票，如需查看明細請上慈濟單位網站查看
          </Text>
        </VStack>
      ),
    ],
    [fp.T, fp.always(null)],
  ])(paymentType);
}
